<div class="document-position-header">
    <div class="document-position" [class.no-prices]="viewMode === 'purchase' && !hasAccessTo.viewBuyPrices && document.salesDocumentTypeId !== 5" [class.non-valuated]="position.priceBeforeDiscountsValue == null">

        <div
            class="flex-col image width-3"
            *ngIf="!showDetails"
        >

            <img
                *ngIf="position.photos?.length"
                [src]="hostname + '/' + position.photos[0].img"
                [alt]="position.photos[0].alt"
                [title]="position.photos[0].title"
            >

            <icc-sketch
                *ngIf="position?.configuration?.sketchMainData"
                [sketchData]="position?.configuration?.sketchMainData"
                [sketchPhotos]="position?.configuration?.sketchMainData?.photos"
                [optionPhotos]="position?.configuration?.sketchMainData?.optionPhotos"
                [details]="position?.configuration"
                [previewWidth]="mobileView ? 75 : 120"
                [previewHeight]="mobileView ? 75 : 120"
                [width]="mobileView ? 75 : 120"
                [height]="mobileView ? 75 : 120"
                [redrawCycle] = "false"
                [host]="hostname"
            ></icc-sketch>

            <div class="draw" *ngIf="position.type !== 'complex' && !isStaticPosition(position) && thumbnailDrawType === 'normal' && showDraws">
                <icc-draw #draw [details]="position.configuration" [options]="thumbnailDrawOptions" (viewBoxDimensions)="viewBoxDimensions($event)"> </icc-draw>
            </div>

            <div class="draw" *ngIf="position.type !== 'complex' && !isStaticPosition(position) && thumbnailDrawType === 'top-projection' && showDraws">
                <icc-draw #draw [details]="position.configuration" [options]="thumbnailTopProjectionDrawOptions" (viewBoxDimensions)="viewBoxDimensions($event)"> </icc-draw>
            </div>

            <div class="draw" *ngIf="position.type === 'external_venetian' && thumbnailDrawType === 'text'">
                {{ 'EXTERNAL_VENETIAN| {count} żaluzji' | translate:{ count: position?.configuration?.shutters?.length || 0 } }}<br>
                <ng-container *ngIf="position.configuration?.coverType?.type === 'blind_box'">
                    {{ 'EXTERNAL_VENETIAN| {count} skrzynek' | translate:{ count: position?.configuration?.coverSegments?.length || 0 } }}
                </ng-container>
                <ng-container *ngIf="position.configuration?.coverType?.type === 'blind_sheet_set' || position.configuration?.coverType?.type === 'blind_sheet'">
                    {{ 'EXTERNAL_VENETIAN| {count} blach' | translate:{ count: position?.configuration?.coverSegments?.length || 0 } }}
                </ng-container>
            </div>

        </div>

        <div
            class="position-header"
            [ngClass]="{'show-details': showDetails}"
        >

            <div class="position-header--header">

                <div class="title">
                    {{ index + 1 + '. '}}&nbsp;
                    <ng-container *ngIf="positionTitle?.length">
                        <ng-container *ngFor="let crumb of positionTitle; index as i">
                            <icc-icon name="navigate_next" *ngIf="i > 0"></icc-icon>
                            {{ crumb }}
                        </ng-container>
                    </ng-container>
                </div>

                <div
                    class="flex-row name"
                >

                    <icc-inplace *ngIf="hasAccessTo.positionName && !sorting">
                        <ng-template iccTemplate="display">
                            <span class="icc-inplace-display" *ngIf="position.name">{{position.name}} <icc-icon name="edit"></icc-icon></span>
                            <span class="icc-inplace-display" *ngIf="!position.name"><i>{{ 'SALES_DOCUMENT|kliknij, aby dodać nazwę własną' | translate}}</i> <icc-icon class="icc-inplace-display" name="edit"></icc-icon></span>
                        </ng-template>
                        <ng-template iccTemplate="content">
                            <icc-input
                                size="small"
                                [value]="position.name"
                                (valueChange)="changePositionName($event)"
                                name="position-name"
                                iccInplaceFocus
                            >
                            </icc-input>
                        </ng-template>
                    </icc-inplace>
                    <span *ngIf="!hasAccessTo.positionName || sorting">
                        <span>{{position.name}}</span>
                    </span>
                </div>


                <div
                    class="flex-row actions"
                    *ngIf="!sorting && !mobileView"
                >
                    <button
                        iccIconButton
                        (click)="openPositionPricesDialog()"
                        [title]="'SALES_DOCUMENT|Ceny i rabaty' | translate"
                        appearance="flat"
                        *ngIf="(viewMode !== 'purchase' || hasAccessTo.viewBuyPrices) && document?.salesDocumentTypeId !== 5"
                    >
                        <icc-icon name="margin_markup"></icc-icon>
                    </button>
                    <ng-container *ngIf="openedDocument?.externalSource !== 'ERP'">
                        <ng-container *ngFor="let action of actions">
                            <button
                                iccIconButton
                                (click)="action.action()"
                                [title]="action.label | translate"
                                appearance="flat"
                                *ngIf="action.when()"
                                [disabled]="action.disabled && action.disabled()"
                            >
                                <icc-icon [name]="action.icon"></icc-icon>
                            </button>
                        </ng-container>
                        <button
                            iccIconButton
                            (click)="switchShowDetails(!showDetails)"
                            [title]="'SALES_DOCUMENT|Pozycja z konfiguratora - więcej informaci w szczegółach pozycji' | translate"
                            *ngIf="getPositionMasters().length"
                            appearance="flat"
                        >
                            <icc-icon name="link"></icc-icon>
                        </button>
                    </ng-container>
                    <button
                        *ngIf="document?.salesDocumentTypeId !== 5"
                        iccIconButton
                        (click)="switchShowDetails(!showDetails)"
                        [title]="'INTERFACE|Szczegóły' | translate"
                        appearance="flat"
                    >
                        <icc-icon
                            *ngIf="showDetails"
                            name="compress"
                        ></icc-icon>

                        <icc-icon
                            *ngIf="!showDetails"
                            name="expand"
                        ></icc-icon>

                    </button>

                </div>
            </div>

            <div
                class="flex-row code width-1"
                *ngIf="position?.configuration?.code && !position?.configuration?.index && !showDetails"
            >

                <span class="uppercase" >{{ 'PRODUCT|Index:' | translate }}</span> {{position.configuration.code}}

            </div>
            <div
                class="flex-row code width-1"
                *ngIf="position?.configuration?.index && !showDetails"
            >
                <span class="uppercase">{{ 'PRODUCT|Indeks:' | translate }}</span> {{position.configuration.index}}
            </div>
            <div
                class="flex-row code width-1"
                *ngIf="position.type === 'external_venetian' && !showDetails"
            >
                <span class="uppercase" >{{ 'EXTERNAL_VENETIAN|Wymiary:' | translate }}</span> {{ formatUnit(position?.configuration?.billingWidth || position?.configuration?.width || 0) }} x {{ formatUnit(position?.configuration?.height || 0) }}
            </div>

            <div class="flex-row width-1 flex-justify-start" *ngIf="!mobileView && hasAccessTo.commitDelivery">
                <div *ngIf="hasAccessTo.commitDelivery">
                    <icc-checkbox
                        [ngModel]="position?.isDelivered"
                        (ngModelChange)="changePositionDelivered($event)"
                        [disabled]="deliveryConfirmed"
                    >
                        {{ 'DELIVERY|Dostarczony' | translate }}
                    </icc-checkbox>
                </div>
                <p class="quantity">{{ position.quantity }} {{ position?.configuration?.unit | unit: position.quantity : true }}</p>
            </div>

            <div class="flex-row width-1 data" *ngIf="(viewMode !== 'purchase' || hasAccessTo.viewBuyPrices || document.salesDocumentTypeId === 5) && !mobileView">

                <div class="flex-col width-1" *ngIf="document?.discountType === 'value' && document.salesDocumentTypeId !== 5">
                        <div class="flex-row width-1">
                            <div class="width-7"></div>
                            <div class="width-7 title">

                                <ng-container *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Cena bazowa netto:' | translate }}
                                </ng-container>
                                <ng-container *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Cena bazowa brutto:' | translate }}
                                </ng-container>

                            </div>
                            <div class="width-7 title">

                                <ng-container *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Suma dopłat  netto:' | translate }}
                                </ng-container>
                                <ng-container *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Suma dopłat  brutto:' | translate }}
                                </ng-container>

                            </div>
                            <div class="width-7 title" [class.width-7]="!editUnit" [class.width-6-4]="editUnit" [class.center]="editUnit">

                                {{ 'SALES_DOCUMENT|Ilość' | translate }}

                            </div>
                            <div class="width-7 title">
                                {{ 'SALES_DOCUMENT|Rabat' | translate }}
                            </div>
                            <div class="width-7 title">

                                <ng-container class="icc-card__label" *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Wartość netto:' | translate }}
                                </ng-container>
                                <ng-container class="icc-card__label" *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Wartość brutto:' | translate }}
                                </ng-container>

                            </div>
                        </div>
                        <div class="flex-row width-1" [class.edit-unit]="editUnit">
                            <div class="width-7">

                                <div class=" width-1 height-1 primary-title">

                                    <span class="width-1" *ngIf="saleView">
                                        {{ 'SALES_DOCUMENT|Cena sprzedaży' | translate }}
                                    </span>

                                    <span class="width-1" *ngIf="purchaseView">

                                        <ng-container
                                            *ngIf="viewMode === 'purchase' || buyPosition?.priceCurrency === currency"
                                        >
                                            {{ 'SALES_DOCUMENT|Cena zakupu' | translate }}
                                        </ng-container>

                                        <ng-container *ngIf="viewMode !== 'purchase' && buyPosition?.priceCurrency !== currency">
                                            {{ 'SALES_DOCUMENT|Cena zakupu - przeliczona na {salesCurrency}' | translate: { salesCurrency: currency } }}
                                            <i class="buy-currency-price"> ({{ buyPosition?.priceCurrency }}) </i>
                                        </ng-container>

                                    </span>

                                </div>

                            </div>
                            <div class="width-7">

                                <span class="width-1" *ngIf="saleView">
                                    <span *ngIf="priceBasePromotion !== 0" class="price-before-promotion">{{ priceBaseBeforePromotion | currency: currency }}</span>
                                    <span *ngIf="priceBasePromotion !== 0" class="percent-promotion">{{ -priceBasePromotion }}%</span>
                                    <span>{{ priceBase | currency: currency }}</span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="price-before-promotion">{{ buyPriceBaseBeforePromotion | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="percent-promotion">{{ -buyPriceBasePromotion }}%</span>
                                    <span>{{ buyPriceBase | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ buyPriceBase | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="price-before-promotion">{{ buyPriceBaseBeforePromotion | currency: buyPosition?.priceCurrency }}</span>
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="percent-promotion">{{ -buyPriceBasePromotion }}%</span>
                                    <span>{{ buyPriceBase | currency: buyPosition?.priceCurrency }}</span>
                                </span>

                            </div>
                            <div class="width-7">

                                <span class="width-1" *ngIf="saleView">
                                    <span *ngIf="priceSurchargesPromotion !== 0" class="price-before-promotion">{{ priceSurchargesBeforePromotion | currency: currency }}</span>
                                    <span *ngIf="priceSurchargesPromotion !== 0" class="percent-promotion">{{ -priceSurchargesPromotion }}%</span>
                                    <span>{{ priceSurcharges | currency: currency }}</span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="price-before-promotion">{{ buyPriceSurchargesBeforePromotion | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="percent-promotion">{{ -buyPriceSurchargesPromotion }}%</span>
                                    <span>{{ buyPriceSurcharges | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ buyPriceSurcharges | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="price-before-promotion">{{ buyPriceSurchargesBeforePromotion | currency: buyPosition?.priceCurrency }}</span>
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="percent-promotion">{{ -buyPriceSurchargesPromotion }}%</span>
                                    <span>{{ buyPriceSurcharges | currency: buyPosition?.priceCurrency }}</span>
                                </span>

                            </div>
                            <div [class.width-7]="!editUnit" [class.width-6-4]="editUnit">
                                <div class=" flex-col item-right right">
                                    <div
                                        *ngIf="saleView"
                                        class="item-right right"
                                        [class]="getWidthInputClass(position?.quantity,editUnit)"
                                    >
                                        <icc-form-field
                                            size="small"
                                            [class.width-33]="editUnit"
                                        >
                                            <icc-icon
                                                *ngIf="!editUnit && hasAccessTo.quantity"
                                                name="add"
                                                (click)="changePositionQuantity(+position.quantity + 1)"
                                            ></icc-icon>
                                            <icc-input
                                                [value]="position.quantity"
                                                (valueChange)="changePositionQuantity($event)"
                                                [disabled]="!hasAccessTo.quantity"
                                                [step]="getQuantityStepAndMin()"
                                                name="position-quantity"
                                                type="number"
                                                align="right"
                                                [suffix]="!editUnit && position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:true)|maxLength:4)  : ''"
                                                [suffixTitle]="!editUnit && position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:false)) : ''"
                                                [class.icc-error]="editUnit"
                                                inputmode="decimal"
                                            ></icc-input>
                                            <icc-icon
                                                *ngIf="!editUnit && hasAccessTo.quantity"
                                                name="remove"
                                                (click)="changePositionQuantity(+position.quantity - 1)"
                                            ></icc-icon>
                                        </icc-form-field>
                                        <span class="edit-unit-select" [class.edit-unit-select-comparison]="viewMode === 'comparison'" *ngIf="editUnit">
                                            <icc-select
                                                size="small"
                                                [value]="position?.configuration?.unit?.id"
                                                (valueChange)="handleNewUnitChange($event)"
                                                [supportText]="'SALES_DOCUMENT|Konieczne wybranie jednostki. Poprzednia jednostka: {unit}' | translate: { unit: oldQuantity + ' ' + (position.configuration.unit | unit:position.quantity:true) }"
                                                class="icc-error"
                                            >
                                                <option *ngFor="let unit of matchingPrices" [value]="unit.id + ':' + unit.code">{{ ( unit | unit:position.quantity:true) }}</option>
                                            </icc-select>
                                        </span>

                                        <button
                                            *ngIf="editUnit"
                                            iccIconButton
                                            appearance="primary"
                                            (click)="changeUnit(salesPosition,openedDocument,newUnit)"
                                        >
                                            <icc-icon name="done"></icc-icon>
                                        </button>


                                    </div>

                                    <div
                                        *ngIf="purchaseView"
                                        class="item-right right "
                                        [class]="getWidthInputClass(buyPosition?.quantity)"
                                    >

                                        <icc-input
                                            [value]="buyPosition?.quantity"
                                            [disabled]="true"
                                            type="number"
                                            align="right"
                                            [suffix]="buyPosition?.configuration?.unit ? ((buyPosition.configuration.unit | unit:buyPosition.quantity:true)|maxLength:4)  : ''"
                                            [suffixTitle]="buyPosition?.configuration?.unit?.name ?? ''"
                                        ></icc-input>

                                    </div>

                                </div>

                            </div>
                            <div class="width-7">

                                <span class="width-1 price-with-button" *ngIf="saleView">
                                    <span *ngIf="hasPrice">{{ discountValue | currency: currency }} <ng-container *ngIf="showPercentDiscountInPosition">({{ discountPercent | percent}})</ng-container>
                                        <button
                                            iccIconButton
                                            (click)="openPositionPricesDialog()"
                                            [title]="'SALES_DOCUMENT|Rabaty' | translate"
                                            appearance="flat"
                                            *ngIf="viewMode !== 'purchase' || hasAccessTo.viewBuyPrices"
                                        >
                                            <icc-icon name="visible"></icc-icon>
                                        </button>
                                    </span>
                                </span>

                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="hasBuyPrice">{{ buyDiscountValue | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}({{ buyDiscountPercent | percent}})</span>
                                    <span *ngIf="hasBuyPrice && buyPosition?.priceCurrency != currency">
                                        ({{ buyDiscountValue | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>

                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="hasBuyPrice">{{ buyDiscountValue | currency: buyPosition?.priceCurrency }} ({{ buyDiscountPercent | percent}})</span>
                                </span>

                            </div>
                            <div class="width-7">

                                <span class="width-1" *ngIf="saleView">
                                    {{convertToNetSalesPrice(position.priceAfterDiscountsValue) | currency: currency}}
                                </span>

                                <span class="width-1"  *ngIf="purchaseView && viewMode === 'comparison'">
                                    {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency}}
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1"  *ngIf="purchaseView && viewMode === 'purchase'">
                                    {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }}
                                </span>

                            </div>
                        </div>
                </div>

                <div class="flex-col width-1 data" *ngIf="document?.discountType === 'price' && document.salesDocumentTypeId !== 5">
                        <div class="flex-row width-1" *ngIf="viewMode !== 'purchase' || hasAccessTo.viewBuyPrices">
                            <div class="width-7 "></div>
                            <div class="width-7 title">

                                <ng-container *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Cena bazowa netto:' | translate }}
                                </ng-container>
                                <ng-container *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Cena bazowa brutto:' | translate }}
                                </ng-container>

                            </div>
                            <div class="width-7 title">

                                <ng-container *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Suma dopłat  netto:' | translate }}
                                </ng-container>
                                <ng-container *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Suma dopłat  brutto:' | translate }}
                                </ng-container>

                            </div>
                            <div class="width-7 title">

                                {{ 'SALES_DOCUMENT|Rabat' | translate }}

                            </div>
                            <div class="width-7 title">
                                <ng-container class="icc-card__label" *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Cena z rabatem netto:' | translate }}
                                </ng-container>
                                <ng-container class="icc-card__label" *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Cena z rabatem brutto:' | translate }}
                                </ng-container>
                            </div>
                            <div class="title" [class.width-7]="!editUnit" [class.width-6-4]="editUnit" [class.center]="editUnit">

                                {{ 'SALES_DOCUMENT|Ilość:' | translate }}

                            </div>
                            <div class="width-7 title">

                                {{ 'SALES_DOCUMENT|Stawka VAT:' | translate }}

                            </div>
                            <div class="width-7 title">

                                <ng-container class="icc-card__label" *ngIf="!isGross">
                                    {{ 'SALES_DOCUMENT|Wartość netto:' | translate }}
                                </ng-container>
                                <ng-container class="icc-card__label" *ngIf="isGross">
                                    {{ 'SALES_DOCUMENT|Wartość brutto:' | translate }}
                                </ng-container>

                            </div>
                        </div>
                        <div class="flex-row width-1" [class.edit-unit]="editUnit" *ngIf="viewMode !== 'purchase' || hasAccessTo.viewBuyPrices">
                            <div class="width-7 ">

                                <div class=" width-1 height-1 primary-title">

                                    <span class="width-1" *ngIf="saleView">
                                        {{ 'SALES_DOCUMENT|Cena sprzedaży' | translate }}
                                    </span>

                                    <span class="width-1" *ngIf="purchaseView">

                                        <ng-container
                                            *ngIf="viewMode === 'purchase' || buyPosition?.priceCurrency === currency"
                                        >
                                            {{ 'SALES_DOCUMENT|Cena zakupu' | translate }}
                                        </ng-container>

                                        <ng-container *ngIf="viewMode !== 'purchase' && buyPosition?.priceCurrency !== currency">
                                            {{ 'SALES_DOCUMENT|Cena zakupu - przeliczona na {salesCurrency}' | translate: { salesCurrency: currency } }}
                                            <i class="buy-currency-price"> ({{ buyPosition?.priceCurrency }})</i>
                                        </ng-container>

                                    </span>

                                </div>

                            </div>
                            <div class="width-7 ">

                                <span class="width-1" *ngIf="saleView">
                                    <span *ngIf="priceBasePromotion !== 0" class="price-before-promotion">{{ priceBaseBeforePromotion | currency: currency }}</span>
                                    <span *ngIf="priceBasePromotion !== 0" class="percent-promotion">{{ -priceBasePromotion }}%</span>
                                    <span>{{ priceBase | currency: currency }}</span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="price-before-promotion">{{ buyPriceBaseBeforePromotion | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="percent-promotion">{{ -buyPriceBasePromotion }}%</span>
                                    <span>{{ buyPriceBase | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ buyPriceBase | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="price-before-promotion">{{ buyPriceBaseBeforePromotion | currency: buyPosition?.priceCurrency }}</span>
                                    <span *ngIf="buyPriceBasePromotion !== 0" class="percent-promotion">{{ -buyPriceBasePromotion }}%</span>
                                    <span>{{ buyPriceBase | currency: buyPosition?.priceCurrency }}</span>
                                </span>

                            </div>
                            <div class="width-7 ">

                                <span class="width-1" *ngIf="saleView">
                                    <span *ngIf="priceSurchargesPromotion !== 0" class="price-before-promotion">{{ priceSurchargesBeforePromotion | currency: currency }}</span>
                                    <span *ngIf="priceSurchargesPromotion !== 0" class="percent-promotion">{{ -priceSurchargesPromotion }}%</span>
                                    <span>{{ priceSurcharges | currency: currency }}</span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="price-before-promotion">{{ buyPriceSurchargesBeforePromotion | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="percent-promotion">{{ -buyPriceSurchargesPromotion }}%</span>
                                    <span>{{ buyPriceSurcharges | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }}</span>
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ buyPriceSurcharges | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="price-before-promotion">{{ buyPriceSurchargesBeforePromotion | currency: buyPosition?.priceCurrency }}</span>
                                    <span *ngIf="buyPriceSurchargesPromotion !== 0" class="percent-promotion">{{ -buyPriceSurchargesPromotion }}%</span>
                                    <span>{{ buyPriceSurcharges | currency: buyPosition?.priceCurrency }}</span>
                                </span>

                            </div>
                            <div class="width-7 ">

                                <span class="width-1 price-with-button" *ngIf="saleView">
                                    <span *ngIf="hasPrice">{{ discountValue | currency: currency }} <ng-container *ngIf="showPercentDiscountInPosition">({{ discountPercent | percent}})</ng-container>
                                        <button
                                            iccIconButton
                                            (click)="openPositionPricesDialog()"
                                            [title]="'SALES_DOCUMENT|Rabaty' | translate"
                                            appearance="flat"
                                            *ngIf="viewMode !== 'purchase' || hasAccessTo.viewBuyPrices"
                                        >
                                            <icc-icon name="visible"></icc-icon>
                                    </button>
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    <span *ngIf="hasBuyPrice">{{ buyDiscountValue | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency }} ({{ buyDiscountPercent | percent}})</span>
                                    <span *ngIf="hasBuyPrice && buyPosition?.priceCurrency != currency">
                                        ({{ buyDiscountValue | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    <span *ngIf="hasBuyPrice">{{ buyDiscountValue | currency: buyPosition?.priceCurrency }} ({{ buyDiscountPercent | percent}})</span>
                                </span>
                            </div>
                            <div class="width-7 ">

                                <span class="width-1" *ngIf="saleView">
                                    {{convertToNetSalesPrice(position.priceAfterDiscountsValue) | currency: currency}}
                                </span>
                                <span  class="width-1" *ngIf="purchaseView && viewMode === 'comparison'">
                                    {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency}}
                                    <span *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span  class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    {{ buyPosition?.priceAfterDiscountsValue | currency: buyPosition?.priceCurrency }}
                                </span>

                            </div>
                            <div [class.width-7]="!editUnit" [class.width-6-4]="editUnit">
                                <div class="flex-col item-right right">
                                    <div
                                        *ngIf="saleView"
                                        class="item-right right"
                                        [class]="getWidthInputClass(position?.quantity, editUnit)"
                                    >
                                        <icc-form-field
                                            size="small"
                                            [class.width-33]="editUnit"
                                        >
                                            <icc-icon
                                                *ngIf="hasAccessTo.quantity && !editUnit"
                                                name="add"
                                                (click)="changePositionQuantity(+position.quantity + 1)"
                                            ></icc-icon>
                                            <icc-input
                                                [value]="position.quantity"
                                                (valueChange)="changePositionQuantity($event)"
                                                [disabled]="!hasAccessTo.quantity"
                                                [step]="getQuantityStepAndMin()"
                                                name="position-quantity"
                                                type="number"
                                                align="right"
                                                [class.icc-error]="editUnit"
                                                [suffix]="!editUnit && position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:true)|maxLength:4) : ''"
                                                [suffixTitle]="position?.configuration?.unit?.name ?? ''"
                                                inputmode="decimal"
                                            ></icc-input>
                                            <icc-icon
                                                *ngIf="hasAccessTo.quantity && !editUnit"
                                                name="remove"
                                                (click)="changePositionQuantity(+position.quantity - 1)"
                                            ></icc-icon>

                                        </icc-form-field>

                                        <span class="edit-unit-select" [class.edit-unit-select-comparison]="viewMode === 'comparison'" *ngIf="editUnit">
                                            <icc-select
                                                size="small"
                                                [value]="position?.configuration?.unit?.id"
                                                (valueChange)="handleNewUnitChange($event)"
                                                [supportText]="'SALES_DOCUMENT|Konieczne wybranie jednostki. Poprzednia jednostka: {unit}' | translate: { unit: oldQuantity + ' ' + (position.configuration.unit | unit:position.quantity:true) }"
                                                class="icc-error"
                                            >
                                                <option *ngFor="let unit of matchingPrices" [value]="unit.id + ':' + unit.code">{{ ( unit | unit:position.quantity:true) }}</option>
                                            </icc-select>
                                        </span>

                                        <button
                                            *ngIf="editUnit"
                                            iccIconButton
                                            appearance="primary"
                                            (click)="changeUnit(salesPosition,openedDocument,newUnit)"
                                        >
                                            <icc-icon name="done"></icc-icon>
                                        </button>


                                    </div>

                                    <div
                                        *ngIf="purchaseView"
                                        class="item-right right "
                                        [class]="getWidthInputClass(buyPosition?.quantity)"
                                    >

                                        <icc-input
                                            [value]="buyPosition?.quantity"
                                            [disabled]="true"
                                            type="number"
                                            align="right"
                                            [suffix]="buyPosition?.configuration?.unit ? ((buyPosition.configuration.unit | unit:buyPosition.quantity:true)|maxLength:4)  : ''"
                                            [suffixTitle]="buyPosition?.configuration?.unit?.name ?? ''"
                                        ></icc-input>

                                    </div>

                                </div>
                            </div>
                            <div class="width-7">
                                <span class="width-1" *ngIf="saleView">
                                    <icc-select [ngModel]="position?.priceTaxRateId"
                                        (ngModelChange)="changePositionTaxRate($event)"
                                        *ngIf="openedDocument?.isCustomTaxRatesMode && !openedDocument?.isOneTaxRateMode && hasAccessTo.taxRate"
                                        >
                                        <option *ngFor="let rate of taxRates" [value]="rate.id">{{ rate.name }}</option>
                                    </icc-select>
                                    <span *ngIf="!openedDocument?.isCustomTaxRatesMode || openedDocument?.isOneTaxRateMode || !hasAccessTo.taxRate">
                                        {{position?.priceTaxRate / 100 | percent }}
                                    </span>
                                </span>
                                <span class="width-1" *ngIf="purchaseView">
                                    {{buyPosition?.priceTaxRate / 100 | percent }}
                                </span>
                            </div>
                            <div class="width-7 ">

                                <span  class="width-1" *ngIf="saleView">
                                    {{ (position.priceAfterDiscountsValue !== null ? (convertToNetSalesPrice(position.priceAfterDiscountsValue) * ( position.quantity )) : null) | currency: currency}}
                                </span>
                                <span  class="width-1"  *ngIf="purchaseView && viewMode === 'comparison'">
                                    {{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency}}
                                    <span  *ngIf="buyPosition?.priceCurrency != currency">
                                        ({{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | currency: buyPosition?.priceCurrency }})
                                    </span>
                                </span>
                                <span  class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                                    {{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | currency: buyPosition?.priceCurrency }}
                                </span>

                            </div>
                        </div>
                </div>

                <div class="flex-col width-1" *ngIf="document?.salesDocumentTypeId === 5">
                    <div class="flex-row width-1">
                        <div class="width-7 title">
                            {{ 'SALES_DOCUMENT|Ilość' | translate }}
                        </div>
                    </div>
                    <div class="flex-row width-1">
                        <div class="width-7">
                            <div class=" flex-col item-right right">
                                <div
                                    class="item-right right"
                                    [class]="getWidthInputClass(position?.quantity,editUnit)"
                                >
                                    <icc-form-field
                                        size="small"
                                    >
                                        <icc-icon
                                            *ngIf="hasAccessTo.quantity"
                                            name="add"
                                            (click)="changePositionQuantity(+position.quantity + 1)"
                                        ></icc-icon>
                                        <icc-input
                                            [value]="position.quantity"
                                            (valueChange)="changePositionQuantity($event)"
                                            [disabled]="!hasAccessTo.quantity"
                                            [step]="getQuantityStepAndMin()"
                                            name="position-quantity"
                                            type="number"
                                            align="right"
                                            [suffix]="position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:true)|maxLength:4)  : ''"
                                            [suffixTitle]="position?.configuration?.unit?.name ?? ''"
                                            [class.icc-error]="editUnit"
                                            inputmode="decimal"
                                        ></icc-input>
                                        <icc-icon
                                            *ngIf="hasAccessTo.quantity"
                                            name="remove"
                                            (click)="changePositionQuantity(+position.quantity - 1)"
                                        ></icc-icon>
                                    </icc-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
    <div class="document-position-prices" *ngIf="(viewMode !== 'purchase' || hasAccessTo.viewBuyPrices) && mobileView">
        <div class="prices-labels primary-title" *ngIf="viewMode ==='comparison'">
            <span *ngIf="saleView">
                {{ 'SALES_DOCUMENT|Sprzedaż' | translate }}
            </span>

            <span *ngIf="purchaseView">

                <ng-container
                    *ngIf="viewMode === 'purchase' || buyPosition?.priceCurrency === currency"
                >
                    {{ 'SALES_DOCUMENT|Zakup' | translate }}
                </ng-container>

                <ng-container *ngIf="viewMode !== 'purchase' && buyPosition?.priceCurrency !== currency">
                    {{ 'SALES_DOCUMENT|Zakup - przeliczona na {salesCurrency}' | translate: { salesCurrency: currency } }}
                    <i class="buy-currency-price"> ({{ buyPosition?.priceCurrency }})</i>
                </ng-container>

            </span>
        </div>
        <div *ngIf="hasAccessTo.commitDelivery">
            <icc-checkbox
                [ngModel]="position?.isDelivered"
                (ngModelChange)="changePositionDelivered($event)"
                [disabled]="deliveryConfirmed"
            >
                {{ 'DELIVERY|Dostarczony' | translate }}
            </icc-checkbox>
        </div>
        <div class="quantity-container" [class.edit-unit]="editUnit" *ngIf="!hasAccessTo.commitDelivery">
            <div
                *ngIf="saleView"
                class="item-right right"
                [class]="getWidthInputClass(position?.quantity,editUnit)"
            >
                <icc-form-field
                    size="small"
                    [class.width-33]="editUnit"
                >
                    <icc-icon
                        *ngIf="!editUnit && hasAccessTo.quantity"
                        name="add"
                        (click)="changePositionQuantity(+position.quantity + 1)"
                    ></icc-icon>
                    <icc-input
                        [value]="position.quantity"
                        (valueChange)="changePositionQuantity($event)"
                        [disabled]="!hasAccessTo.quantity"
                        [step]="getQuantityStepAndMin()"
                        name="position-quantity"
                        type="number"
                        align="right"
                        [suffix]="!editUnit && position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:true)|maxLength:4)  : ''"
                        [suffixTitle]="position?.configuration?.unit?.name ?? ''"
                        [class.icc-error]="editUnit"
                        inputmode="decimal"
                    ></icc-input>
                    <icc-icon
                        *ngIf="!editUnit && hasAccessTo.quantity"
                        name="remove"
                        (click)="changePositionQuantity(+position.quantity - 1)"
                    ></icc-icon>
                </icc-form-field>
                <span class="edit-unit-select" [class.edit-unit-select-comparison]="viewMode === 'comparison'" *ngIf="editUnit">
                    <icc-select
                        size="small"
                        [value]="position?.configuration?.unit?.id"
                        (valueChange)="handleNewUnitChange(+ $event)"
                        [supportText]="'SALES_DOCUMENT|Konieczne wybranie jednostki. Poprzednia jednostka: {unit}' | translate: { unit: oldQuantity + ' ' + (position.configuration.unit | unit:position.quantity:true) }"
                        class="icc-error"
                    >
                        <option *ngFor="let unit of matchingPrices" [value]="unit.id">{{ ( unit | unit:position.quantity:true) }}</option>
                    </icc-select>
                </span>

                <button
                    *ngIf="editUnit"
                    iccIconButton
                    appearance="primary"
                    (click)="changeUnit(salesPosition,openedDocument,newUnit)"
                >
                    <icc-icon name="done"></icc-icon>
                </button>


            </div>

            <div
                *ngIf="purchaseView"
                class="item-right right "
                [class]="getWidthInputClass(buyPosition?.quantity)"
            >

                <icc-input
                    [value]="buyPosition?.quantity"
                    [disabled]="true"
                    type="number"
                    align="right"
                    [suffix]="buyPosition?.configuration?.unit ? ((buyPosition.configuration.unit | unit:buyPosition.quantity:true)|maxLength:4)  : ''"
                    [suffixTitle]="buyPosition?.configuration?.unit?.name ?? ''"
                ></icc-input>

            </div>

        </div>
        <div class="quantity-container" *ngIf="hasAccessTo.commitDelivery">
            <p class="quantity">{{ position.quantity }} {{ position?.configuration?.unit ? ((position.configuration.unit | unit:position.quantity:fals)) : ''}}</p>
        </div>
        <div class="total-price" *ngIf="document?.discountType === 'value' && document.salesDocumentTypeId !== 5">

            <span class="width-1" *ngIf="saleView">
                {{convertToNetSalesPrice(position.priceAfterDiscountsValue) | currency: currency}}
            </span>

            <span class="width-1"  *ngIf="purchaseView && viewMode === 'comparison'">
                {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency}}
                <span *ngIf="buyPosition?.priceCurrency != currency">
                    ({{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }})
                </span>
            </span>
            <span class="width-1"  *ngIf="purchaseView && viewMode === 'purchase'">
                {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }}
            </span>

        </div>
        <div class="total-price " *ngIf="document?.discountType === 'price' && document.salesDocumentTypeId !== 5">

            <span  class="width-1" *ngIf="saleView">
                {{ (position.priceAfterDiscountsValue !== null ? (convertToNetSalesPrice(position.priceAfterDiscountsValue) * ( position.quantity )) : null) | currency: currency}}
            </span>
            <span  class="width-1"  *ngIf="purchaseView && viewMode === 'comparison'">
                {{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | exchange: buyPosition?.priceCurrency : currency : buyExchangeRates | currency: currency}}
                <span  *ngIf="buyPosition?.priceCurrency != currency">
                    ({{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | currency: buyPosition?.priceCurrency }})
                </span>
            </span>
            <span  class="width-1" *ngIf="purchaseView && viewMode === 'purchase'">
                {{ (buyPosition.priceAfterDiscountsValue !== null ? (convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) * ( buyPosition?.quantity)) : null) | currency: buyPosition?.priceCurrency }}
            </span>

        </div>
    </div>
    <div class="document-position-actions" *ngIf="mobileView">
        <button
            *ngIf="document?.salesDocumentTypeId !== 5"
            iccIconButton
            (click)="switchShowDetails(!showDetails)"
            [title]="'INTERFACE|Szczegóły' | translate"
            appearance="flat"
        >
            <icc-icon
                *ngIf="showDetails"
                name="compress"
            ></icc-icon>

            <icc-icon
                *ngIf="!showDetails"
                name="expand"
            ></icc-icon>
        </button>
        <button
            iccIconButton
            (click)="openPositionPricesDialog()"
            [title]="'SALES_DOCUMENT|Ceny i rabaty' | translate"
            appearance="flat"
            *ngIf="document && (viewMode !== 'purchase' || hasAccessTo.viewBuyPrices) && document.salesDocumentTypeId !== 5"
        >
            <icc-icon name="margin_markup"></icc-icon>
        </button>
        <button
            iccIconButton
            appearance="flat"
            *ngIf="hasAccessToAny(actions)"
            [iccMenuTriggerFor]="positionActionsMenu"
        >
            <icc-icon name="menu"></icc-icon>
        </button>
    </div>
    <icc-menu #positionActionsMenu="iccMenu" xPosition="before" yPosition="below" class="position-actions-menu">
        <ng-container *ngFor="let action of actions">
            <button
                icc-menu-item
                (click)="action.action()"
                *ngIf="action.when()"
                [disabled]="action.disabled && action.disabled()"
            >
                <icc-icon [name]="action.icon"></icc-icon>
                <span>{{ action.label | translate }}</span>
            </button>
        </ng-container>
    </icc-menu>
</div>

<div class="draw-wide" *ngIf="showDetails && position.type !== 'complex' && !isStaticPosition(position) && showPositionWideDraw()">
    <icc-draw #draw [details]="position.configuration" [options]="drawOptions" (viewBoxDimensions)="viewBoxDimensions($event)"> </icc-draw>
    <p class="draw-caption">{{ "DRAW|Widok wewnętrzny" | translate }}</p>
</div>
<div
    class="document-position-details"
    *ngIf="showDetails"
>

    <div
        class="flex-col image width-5"
    >

        <img
            *ngIf="position.photos?.length"
            [src]="hostname + '/' + position.photos[0].img"
            [alt]="position.photos[0].alt"
            [title]="position.photos[0].title"
        >



        <icc-sketch
            *ngIf="position?.configuration?.sketchMainData"
            [sketchData]="position?.configuration?.sketchMainData"
            [sketchPhotos]="position?.configuration?.sketchMainData?.photos"
            [optionPhotos]="position?.configuration?.sketchMainData?.optionPhotos"
            [details]="position?.configuration"
            previewWidth="260"
            previewHeight="260"
            width="260"
            height="260"
            [redrawCycle] = "false"
        ></icc-sketch>

        <ng-container *ngFor="let sketch of position?.configuration?.sketchAdditionalData" >

            <icc-sketch
                [sketchData]="sketch"
                [sketchPhotos]="sketch?.photos"
                [optionPhotos]="sketch?.optionPhotos"
                [details]="sketch?.details"
                previewWidth="260"
                previewHeight="260"
                width="260"
                height="260"
                [redrawCycle] = "false"
            ></icc-sketch>

        </ng-container>

        <div class="draw" *ngIf="position.type !== 'complex' && !isStaticPosition(position) && !showPositionWideDraw()">
            <icc-draw #draw [details]="position.configuration" [options]="drawOptions" (viewBoxDimensions)="viewBoxDimensions($event)"> </icc-draw>
            <p class="draw-caption">{{ "DRAW|Widok wewnętrzny" | translate }}</p>
        </div>

        <div *ngIf="position.type === 'external_venetian' && position?.configuration?.lamella?.img">
            <img
                [src]="hostname + '/files/profiles/' + position.configuration?.lamella?.img"
            >
        </div>

    </div>

    <div
        [class.width-4]="!mobileView"
        [class.width-1]="mobileView"
    >
        <div class="position-configuration" *ngIf="viewMode === 'purchase' && !hasAccessTo.viewBuyPrices && document?.salesDocumentTypeId !== 5">
            <span class="details-label">{{ 'SALES_DOCUMENT|Ilość:' | translate }}</span><span class="details-value">{{ buyPosition?.quantity }}  <ng-container *ngIf="buyPosition?.configuration?.unit">{{ buyPosition?.configuration?.unit ? ((buyPosition.configuration.unit | unit:buyPosition.quantity:true)|maxLength:4)  : ''}}</ng-container></span><br>
        </div>
        <div class="position-configuration" *ngIf="positionTree?.$$children">
            <ng-container *ngFor="let parent of positionTree?.$$children">
                <ng-container *ngIf="parent.$$children?.length">
                    <div class="details-card">
                        <div class="details-card-header">{{parent.name}} <span class="spacer"></span> <span class="details-price" *ngIf="parent.$$price !== 0 && (viewMode !== 'purchase' || hasAccessTo.viewBuyPrices)">{{parent.$$price | currency : (viewMode === 'purchase' ? buyPosition?.priceCurrency : currency)}}</span></div>
                        <div class="details-card-body" *ngIf="parent.$$children?.length">
                            <ul>
                                <li *ngFor="let el of parent.$$children">
                                    <span class="details-label" *ngIf="el.name">{{el.name}}</span><span class="details-value" *ngIf="el.value">: {{el.value}}</span>
                                    <ul *ngIf="el.$$children && el.$$children.length > 0">
                                        <li *ngFor="let el2 of el.$$children">
                                            <span class="details-label" *ngIf="el2.name">{{el2.name}}</span><span class="details-value" *ngIf="el2.value">: {{el2.value}}</span>
                                            <ul *ngIf="el2.$$children && el2.$$children.length > 0">
                                                <li *ngFor="let el3 of el2.$$children">
                                                    <span class="details-label" *ngIf="el3.name">{{el3.name}}</span><span class="details-value" *ngIf="el3.value">: {{el3.value}}</span>
                                                    <ul *ngIf="el3.$$children && el3.$$children.length > 0">
                                                        <li *ngFor="let el4 of el3.$$children">
                                                            <span class="details-label" *ngIf="el4.name">{{el4.name}}</span><span class="details-value" *ngIf="el4.value">: {{el4.value}}</span>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!parent.$$children?.length">
                    <span class="details-label" *ngIf="parent.name">{{parent.name}}:</span> <span class="details-value" *ngIf="parent.value">{{parent.value}}</span><br>
                </ng-container>
            </ng-container>

            <div class="details-card" *ngIf="getPositionSlaves().length">
                <div class="details-card-header">{{ 'SALES_DOCUMENT|Konfiguracja dodaje automatycznie do oferty' | translate }}</div>
                <div class="details-card-body">
                    <ul>
                        <li *ngFor="let slave of getPositionSlaves()">{{slave}}</li>
                    </ul>

                </div>
            </div>
            <div class="details-card" *ngIf="getPositionMasters().length">
                <div class="details-card-header">{{ 'SALES_DOCUMENT|Produkt z konfiguracji' | translate }}</div>
                <div class="details-card-body">
                    <ul>
                        <li *ngFor="let master of getPositionMasters()">{{master}}</li>
                    </ul>
                </div>
            </div>

            <div class="details-card position-description" *ngIf="document?.salesDocumentTypeId !== 5">
                <div class="details-card-header">{{ 'INTERFACE|Opis' | translate }}</div>
                <div class="details-card-body">
                    <icc-inplace *ngIf="hasAccessTo.description" >
                        <ng-template iccTemplate="display">
                            <span *ngIf="position.description" class="document-description commentPre">{{position.description}}</span>
                            <span *ngIf="!position.description">{{ 'INTERFACE|Kliknij, aby ustawić opis' | translate }}</span>
                        </ng-template>
                        <ng-template iccTemplate="content">
                            <textarea [ngModel]="position.description" (ngModelChange)="changePositionDescription($event)" name="position-description" [ngModelOptions]="{updateOn: 'blur'}" iccInplaceFocus></textarea>
                        </ng-template>
                    </icc-inplace>

                    <p class="document-description" *ngIf="!hasAccessTo.description">
                        <span class="commentPre">{{ position.description }}</span>
                    </p>
                </div>
            </div>
            <icc-sales-document-attachments
                [salesDocumentUuid]="document?.uuid"
                [positionUuid]="position.uuid"
                [attachments]="attachments"
                [isConfirmed]="!hasAccessTo.attachments"
                *ngIf="position.type !== 'static' && document?.salesDocumentTypeId !== 5"
            ></icc-sales-document-attachments>
        </div>


    </div>

</div>



